import _classCallCheck from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { getProxiedUrl } from 'gw-portals-url-js';

var SasriaVendorSigninService = /*#__PURE__*/function () {
  function SasriaVendorSigninService() {
    _classCallCheck(this, SasriaVendorSigninService);
  }

  _createClass(SasriaVendorSigninService, null, [{
    key: "isAccessPresentInVE",
    value: function isAccessPresentInVE(userName) {
      var additionalHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return JsonRPCService.send(getProxiedUrl('signup'), 'checkAccessForVE_EXT', [userName], additionalHeaders);
    }
  }]);

  return SasriaVendorSigninService;
}();

export { SasriaVendorSigninService as default };